
import { Link as ScrollLink } from 'react-scroll';


const NavLink = ({ target, children }) => {

    return (
        <>
            <ScrollLink
                to={target}
                smooth={true}
                duration={500}
                offset={-100}
            >
                {children}
            </ScrollLink>
        </>
    )
}


export default NavLink;